module.exports = require("jsqr");